// src/components/SubscriptionCanceled/index.jsx
import { useTheme, useMediaQuery } from "@mui/material";
import SubscriptionCanceledDesktop from "./SubscriptionCanceledDesktop";
import SubscriptionCanceledMobile from "./SubscriptionCanceledMobile";

export default function SubscriptionCanceled() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  return isMobile ? (
    <SubscriptionCanceledMobile />
  ) : (
    <SubscriptionCanceledDesktop />
  );
}
